export const problems = [
  'Clinical findings scattered across different notes and records.',
  'Treatment objectives that are difficult to organize and prioritize.',
  'Biomechanical considerations reviewed inconsistently from case to case.',
  'Treatment sequences that require repeated review and clarification.',
  'Monitoring criteria that are not clearly documented in advance.',
  'Case reassessments that require reconstructing previous decisions.',
  'Valuable time spent organizing information instead of reviewing it systematically.',
]

export const stages = [
  { n: '01', title: 'Assess', color: '#1565F0', text: 'Organize the available clinical records and identify the findings that require consideration.' },
  { n: '02', title: 'Define', color: '#0F9F8F', text: 'Translate the relevant findings into clear, prioritized treatment objectives.' },
  { n: '03', title: 'Analyze', color: '#7A3FE4', text: 'Review movement requirements, biomechanical considerations, and factors that may affect predictability.' },
  { n: '04', title: 'Sequence', color: '#E8730C', text: 'Organize the proposed treatment stages and review the logic behind the planned movements.' },
  { n: '05', title: 'Monitor', color: '#D6334A', text: 'Establish the clinical observations and progress indicators that warrant attention during treatment.' },
  { n: '06', title: 'Reassess', color: '#0A8FC2', text: 'Structure case reviews, document discrepancies, and identify questions that may require further evaluation.' },
]

export const before = [
  'Clinical information reviewed without a consistent sequence.',
  'Treatment objectives recorded in different places.',
  'Biomechanical questions revisited without a standard checklist.',
  'Treatment stages difficult to summarize in one place.',
  'Monitoring considerations documented inconsistently.',
  'Previous decisions harder to review during reassessment.',
]

export const after = [
  'A structured format for organizing clinical findings.',
  'A dedicated framework for documenting treatment objectives.',
  'Checklists for reviewing movement and biomechanical considerations.',
  'Worksheets for mapping treatment stages.',
  'A repeatable structure for monitoring and reassessment.',
  'A consolidated format for summarizing case-planning considerations.',
]
